import React, { useState, useEffect } from 'react';

const Unauthorized = ({ title = 'MatrixBoard', contact, brd_cd, language = 'ko' }) => {
  const isEn = language === 'en';
  const [managerName, setManagerName] = useState(contact || 'AI엔지니어링팀 엄경호');

  useEffect(() => {
    if (contact) {
      setManagerName(contact);
      return;
    }
    if (!brd_cd) return;
    fetch(`/api/users/brand-manager?brd_cd=${encodeURIComponent(brd_cd)}`)
      .then(r => r.json())
      .then(data => { setManagerName(data.success && data.name ? data.name : 'AI엔지니어링팀 엄경호'); })
      .catch(() => { setManagerName('AI엔지니어링팀 엄경호'); });
  }, [brd_cd, contact]);

  const contactLabel = managerName
    ? (isEn ? `Contact: ${managerName}` : `권한 문의: ${managerName}`)
    : (isEn ? 'Contact your administrator' : '관리자에게 문의하세요');

  return (
    <div style={styles.container}>
      <style>{css}</style>
      <div style={styles.card}>
        <div style={styles.topBar} />

        <div style={styles.body}>
          <div style={styles.iconWrap}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM12 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM15.1 8H8.9V6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2z" fill="#fff" />
            </svg>
          </div>

          <p style={styles.appName}>{title}</p>
          <h2 style={styles.heading}>
            {isEn ? 'Access Denied' : '접근 권한이 없습니다'}
          </h2>
          <p style={styles.desc}>
            {isEn ? (
              <>You do not have permission to access this page.<br />Please contact the person below to request access.</>
            ) : (
              <>이 페이지에 접근할 수 있는 권한이 없습니다.<br />아래 담당자에게 권한을 요청해 주세요.</>
            )}
          </p>

          <div style={styles.contactBox}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" fill="#d1d5db" />
            </svg>
            <span style={styles.contactText}>{contactLabel}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;

const css = `
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .unauth-card {
    animation: fadeUp 0.4s ease both;
  }
`;

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100vw',
    backgroundColor: '#f2f2f2',
    fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    boxShadow: '0 2px 16px rgba(0,0,0,0.06)',
    minWidth: '400px',
    overflow: 'hidden',
    animation: 'fadeUp 0.4s ease both',
  },
  topBar: {
    height: '4px',
    backgroundColor: '#9ca3af',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '48px 56px 44px',
  },
  iconWrap: {
    width: '64px',
    height: '64px',
    borderRadius: '50%',
    backgroundColor: '#6b7280',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '24px',
  },
  appName: {
    fontSize: '11px',
    fontWeight: 500,
    color: '#9ca3af',
    letterSpacing: '2.5px',
    textTransform: 'uppercase',
    margin: '0 0 10px 0',
  },
  heading: {
    fontSize: '20px',
    fontWeight: 600,
    color: '#1f2937',
    margin: '0 0 12px 0',
    letterSpacing: '-0.2px',
  },
  desc: {
    fontSize: '13px',
    color: '#9ca3af',
    textAlign: 'center',
    lineHeight: 1.7,
    margin: '0 0 28px 0',
  },
  contactBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: '#f9fafb',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    padding: '12px 20px',
  },
  contactText: {
    fontSize: '13px',
    color: '#4b5563',
  },
};
